/* Heroens stillbilde på telefon: Hjem i LOS Marine Workspace – hilsen, feltet, det som trenger oppmerksomhet – rendret 1:1 i
   telefonbredde inne i et enhetslignende kort. Ingen nettleserramme, intet manus; det bare står der og toner ut nederst. */
import { useEffect, useRef, useState } from "react";
import { Inert } from "../Stage";
import { useCountUp } from "../motion";
import { MobileTop } from "./LosShell";
import { HomeView } from "./LosViews";

export const PhoneStill = ({ height = 700, testId = "tilbod-hero-phone" }) => {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setW(Math.round(e.contentRect.width)));
    ro.observe(el);
    const io = new IntersectionObserver((entries) => setActive(entries[entries.length - 1].isIntersecting), { threshold: 0.15 });
    io.observe(el);
    return () => {
      ro.disconnect();
      io.disconnect();
    };
  }, []);
  useCountUp(ref, active && w > 0, { delay: 600 }, [w > 0]);
  return (
    <div ref={ref} className="kvl-phone mb-frame-like" style={{ height }} data-testid={testId} data-active={active ? "1" : "0"} aria-hidden="true">
      {w > 0 && (
        <div className="mb mb-cine ws kvl-phone-app flex h-full w-full flex-col overflow-hidden bg-white text-foreground" style={{ width: w }} data-testid="mock-hero-dashboard">
          <Inert><MobileTop title="Hjem" /></Inert>
          <Inert className="min-h-0 flex-1">
            <div className="mb-noscroll h-full overflow-hidden"><HomeView beat={0} mode="narrow" /></div>
          </Inert>
        </div>
      )}
    </div>
  );
};
